import '../index.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';

import '../lib/@fontsource/inter/100.css'; // Thin
import '../lib/@fontsource/inter/300.css'; // Light
import '../lib/@fontsource/inter/400.css'; // Regular
import '../lib/@fontsource/inter/500.css'; // Medium
import '../lib/@fontsource/inter/700.css'; // Bold
import '../lib/@fontsource/inter/900.css'; // Black

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { addLocale, locale } from 'primereact/api';
import { useEffect } from 'react';
import localeConfig from '../config/locale';

export const AssetsProvider = ({ children }: { children: JSX.Element }) => {
  addLocale('ru', localeConfig);

  useEffect(() => {
    locale('ru');
  }, []);

  return <>{children}</>;
};
